import { Injectable } from '@angular/core';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { map } from 'rxjs/operators';
import { WhiteLabelRule } from '../white-label-rule';

// This sets the rules for the "base" app, i.e. the login page.
@Injectable()
export class AppWhiteLabelRule implements WhiteLabelRule {
    public whiteLabelRule$ = this._userService.user$.pipe(
        map((user) =>
            !user
                ? {
                      scfPlatformProductName: undefined,
                      scfPlatformPlatformName: undefined,
                      navbarMainBrandLogoIconConfig: undefined,
                      navbarCoBrandLogoAssetPath: undefined
                  }
                : {}
        )
    );

    constructor(private _userService: UserService) {}
}
